export enum EntidadesKeys {
  CENTROS_MEDICOS= 'OBRA_SOCIAL_CENTROS_MEDICOS',
  RUBROS = 'OBRA_SOCIAL_RUBROS',
  ESPECIALIDADES = 'OBRA_SOCIAL_ESPECIALIDADES',
  ZONAS = 'OBRA_SOCIAL_ZONAS',
  CENTROS_PROPIOS_ESPECIALIDADES = 'OBRA_SOCIAL_CENTROS_PROPIOS_ESPECIALIDADES',
  CENTROS_PROPIOS = 'OBRA_SOCIAL_CENTROS_PROPIOS',
}